import { render, staticRenderFns } from "./ThemeSettingsWrapper.vue?vue&type=template&id=27748423&scoped=true"
import script from "./ThemeSettingsWrapper.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27748423",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27748423')) {
      api.createRecord('27748423', component.options)
    } else {
      api.reload('27748423', component.options)
    }
    module.hot.accept("./ThemeSettingsWrapper.vue?vue&type=template&id=27748423&scoped=true", function () {
      api.rerender('27748423', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/projects/themes/ThemeSettingsWrapper.vue"
export default component.exports